// @ts-nocheck
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { calculateAge } from './utils';
import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';

export const downloadOrSharePDF = async (doc: any, filename: string) => {
    if (Capacitor.isNativePlatform()) {
        try {
            const base64 = doc.output('datauristring').split(',')[1];
            const result = await Filesystem.writeFile({
                path: filename,
                data: base64,
                directory: Directory.Cache
            });
            await Share.share({
                title: filename,
                url: result.uri,
                dialogTitle: 'Simpan atau Bagikan Laporan PDF'
            });
        } catch (e) {
            console.error('Error sharing PDF on Native:', e);
            alert('Gagal membuat PDF. Pastikan aplikasi memiliki izin penyimpanan.');
        }
    } else {
        doc.save(filename);
    }
};

export const generateAssessmentPDF = (child, assessment) => {
    const doc = new jsPDF();

    // --- Header ---
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.text('Laporan Hasil Pemeriksaan SIKEMBANG', 105, 20, { align: 'center' });
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(`Tanggal Pemeriksaan: ${assessment.createdAt.toDate().toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' })}`, 105, 28, { align: 'center' });

    doc.line(20, 35, 190, 35); // Horizontal line

    // --- Child's Data ---
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('Data Anak', 20, 45);
    doc.autoTable({
        startY: 50,
        body: [
            ['Nama', `: ${child.name}`],
            ['Tanggal Lahir', `: ${child.dob.toDate().toLocaleDateString('id-ID')}`],
            ['Usia Saat Diperiksa', `: ${calculateAge(child.dob.toDate())}`],
            ['Jenis Kelamin', `: ${child.gender}`],
        ],
        theme: 'plain',
        styles: {
            cellPadding: 1.5,
            fontSize: 11,
        },
    });

    // --- Assessment Results ---
    const finalY = doc.lastAutoTable.finalY || 75;
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('Ringkasan Hasil Pemeriksaan', 20, finalY + 15);

    const tableBody = [];

    // Define all assessment sections with their titles
    const assessmentSections = [
        // Basic assessments
        { key: 'pertumbuhan', title: 'Pertumbuhan Fisik' },
        { key: 'perkembangan', title: 'Perkembangan (KPSP)' },
        { key: 'mental', title: 'Mental Emosional (KMME)' },

        // Specialized assessments
        { key: 'dayaDengar', title: 'Tes Daya Dengar (TDD)' },
        { key: 'gpph', title: 'Gangguan Perhatian & Hiperaktivitas (GPPH)' },
        { key: 'chat', title: 'Autisme (CHAT)' },

        // Eye examination (nested structure)
        { key: 'pemeriksaanMata.pupilPutih', title: 'Pemeriksaan Mata - Pupil Putih' },
        { key: 'pemeriksaanMata.dayaLihat', title: 'Pemeriksaan Mata - Daya Lihat (TDL)' }
    ];

    assessmentSections.forEach(section => {
        let data = null;

        // Handle nested structure for eye examination
        if (section.key.includes('.')) {
            const [parent, child] = section.key.split('.');
            if (assessment[parent] && assessment[parent][child]) {
                data = assessment[parent][child];
            }
        } else if (assessment[section.key]) {
            data = assessment[section.key];
        }

        if (data) {
            tableBody.push([
                section.title,
                data.status || 'N/A',
                data.interpretasi || 'N/A',
                data.detail || 'N/A'
            ]);
        }
    });

    doc.autoTable({
        startY: finalY + 20,
        head: [['Aspek Pemeriksaan', 'Status', 'Interpretasi', 'Detail']],
        body: tableBody,
        theme: 'striped',
        headStyles: { fillColor: [22, 160, 133] }, // A shade of teal
    });

    // --- Footer ---
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(9);
        doc.setTextColor(150);
        doc.text(`Laporan ini dibuat oleh aplikasi SIKEMBANG | Halaman ${i} dari ${pageCount}`, 105, 285, { align: 'center' });
    }

    // --- Save the PDF ---
    downloadOrSharePDF(doc, `Laporan_SIKEMBANG_${child.name.replace(/\s/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);
};

export const generateFullHistoryPDF = (child, assessments, user) => {
    const doc = new jsPDF();

    // --- Header ---
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.text('Rapor Tumbuh Kembang (Riwayat Lengkap)', 105, 20, { align: 'center' });
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(`Dicetak pada: ${new Date().toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' })}`, 105, 28, { align: 'center' });

    doc.line(20, 35, 190, 35); // Horizontal line

    // --- Child's Data ---
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('Data Anak', 20, 45);
    doc.autoTable({
        startY: 50,
        body: [
            ['Nama', `: ${child.name}`],
            ['Tanggal Lahir', `: ${child.dob.toDate().toLocaleDateString('id-ID')}`],
            ['Usia Saat Ini', `: ${calculateAge(child.dob.toDate())}`],
            ['Jenis Kelamin', `: ${child.gender}`],
            ['PAUD / Kelas', `: ${child.schoolName || '-'} / ${child.className || '-'}`]
        ],
        theme: 'plain',
        styles: {
            cellPadding: 1.5,
            fontSize: 11,
        },
        columnStyles: { 0: { fontStyle: 'bold', cellWidth: 40 } }
    });

    let currentY = doc.lastAutoTable.finalY + 10;

    // --- Assessment Results Iterate ---
    assessments.forEach((assessment, index) => {
        // If content is going to overlap page, add a new page
        if (currentY > 250) {
            doc.addPage();
            currentY = 20;
        }

        const dateStr = assessment.createdAt.toDate().toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' });
        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text(`Pemeriksaan: ${dateStr}`, 20, currentY);

        const tableBody = [];
        const assessmentSections = [
            { key: 'pertumbuhan', title: 'Pertumbuhan Fisik' },
            { key: 'perkembangan', title: 'Perkembangan (KPSP)' },
            { key: 'mental', title: 'Mental Emosional (KMME)' },
            { key: 'dayaDengar', title: 'Tes Daya Dengar (TDD)' },
            { key: 'gpph', title: 'Gangguan (GPPH)' },
            { key: 'chat', title: 'Autisme (CHAT)' },
            { key: 'pemeriksaanMata.pupilPutih', title: 'Pemeriksaan Mata (Pupil Putih)' },
            { key: 'pemeriksaanMata.dayaLihat', title: 'Pemeriksaan Mata (TDL)' }
        ];

        assessmentSections.forEach(section => {
            let data = null;
            if (section.key.includes('.')) {
                const [parent, child] = section.key.split('.');
                if (assessment[parent] && assessment[parent][child]) {
                    data = assessment[parent][child];
                }
            } else if (assessment[section.key]) {
                data = assessment[section.key];
            }

            if (data) {
                tableBody.push([
                    section.title,
                    data.status || 'N/A',
                    data.interpretasi || 'N/A'
                ]);
            }
        });

        if (tableBody.length > 0) {
            doc.autoTable({
                startY: currentY + 5,
                head: [['Aspek Pemeriksaan', 'Status', 'Interpretasi']],
                body: tableBody,
                theme: 'striped',
                headStyles: { fillColor: [79, 70, 229] }, // Indigo-600
                styles: { fontSize: 10, cellPadding: 2 },
            });
            currentY = doc.lastAutoTable.finalY + 15;
        } else {
            doc.setFontSize(10);
            doc.setFont('helvetica', 'normal');
            doc.text('Tidak ada detail pemeriksaan tersimpan.', 20, currentY + 7);
            currentY += 15;
        }
    });

    // --- Footer ---
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(9);
        doc.setTextColor(150);
        
        let footerText = `Dicetak oleh: ${user.username || user.email}`;
        if (user.institutionName) {
            footerText += ` | ${user.institutionName}`;
        }
        
        doc.text(footerText, 20, 285);
        doc.text(`Halaman ${i} dari ${pageCount}`, 190, 285, { align: 'right' });
    }

    // --- Save the PDF ---
    downloadOrSharePDF(doc, `Riwayat_Lengkap_${child.name.replace(/\s/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);
};


export const generatePdfFromElement = (elementId: string, filename: string) => {
    console.warn("generatePdfFromElement has not been fully ported yet.");
};

export const generateReferralPDF = (child, referral, user) => {
    const doc = new jsPDF();

    // --- Header ---
    doc.setFontSize(22);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(225, 29, 72); // Rose-600
    doc.text('SURAT RUJUKAN MEDIS', 105, 20, { align: 'center' });
    
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(50);
    doc.text('Aplikasi SIKEMBANG', 105, 28, { align: 'center' });

    doc.setDrawColor(225, 29, 72);
    doc.setLineWidth(1);
    doc.line(20, 35, 190, 35);

    // --- Referral Meta ---
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(80);
    doc.text(`Tanggal Rujukan: ${referral.createdAt.toDate().toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' })}`, 20, 45);
    doc.text(`Urgensi: ${referral.urgency.toUpperCase()}`, 190, 45, { align: 'right' });
    if (referral.destination) {
        doc.text(`Tujuan: ${referral.destination}`, 20, 52);
    }

    // --- Patient Data ---
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0);
    doc.text('Identitas Pasien', 20, 65);
    
    doc.autoTable({
        startY: 70,
        body: [
            ['Nama Lengkap', `: ${child.name}`],
            ['Tanggal Lahir', `: ${child.dob.toDate().toLocaleDateString('id-ID')}`],
            ['Usia', `: ${calculateAge(child.dob.toDate())}`],
            ['Jenis Kelamin', `: ${child.gender}`],
            ['PAUD / Kelas', `: ${child.schoolName || '-'} / ${child.className || '-'}`]
        ],
        theme: 'plain',
        styles: { cellPadding: 2, fontSize: 11, textColor: [30, 30, 30] },
        columnStyles: { 0: { fontStyle: 'bold', cellWidth: 50 } }
    });

    // --- Clinical Data ---
    const finalY = doc.lastAutoTable.finalY || 110;
    
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('Informasi Klinis', 20, finalY + 15);

    doc.autoTable({
        startY: finalY + 20,
        body: [
            ['Diagnosis / Temuan', referral.diagnosis],
            ['Intervensi Awal', referral.intervention || '-']
        ],
        theme: 'grid',
        styles: { cellPadding: 4, fontSize: 11 },
        columnStyles: { 
            0: { fontStyle: 'bold', cellWidth: 50, fillColor: [248, 250, 252] },
            1: { cellWidth: 100 }
        }
    });

    // --- Signatures ---
    const signY = (doc.lastAutoTable.finalY || 160) + 30;
    
    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal');
    doc.text('Mengetahui,', 150, signY, { align: 'center' });
    doc.text('Tenaga Kesehatan', 150, signY + 5, { align: 'center' });
    
    doc.setFont('helvetica', 'bold');
    doc.text(user.username || user.email || 'Petugas Nakes', 150, signY + 25, { align: 'center' });
    
    // --- Footer ---
    doc.setFontSize(9);
    doc.setTextColor(150);
    doc.text('Surat ini digenerate otomatis melalui SIKEMBANG dan sah sebagai dokumen pengantar klinis.', 105, 285, { align: 'center' });

    // --- Save the PDF ---
    downloadOrSharePDF(doc, `Surat_Rujukan_${child.name.replace(/\s/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);
};

export const generateBatchReportCardsPDF = async (className, children) => {
    const doc = new jsPDF('landscape');

    // --- Header ---
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.text(`Laporan Tumbuh Kembang Kelas: ${className}`, 148, 20, { align: 'center' });
    
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(`Tanggal: ${new Date().toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' })}`, 148, 28, { align: 'center' });

    doc.line(14, 35, 283, 35);

    // --- Table Data ---
    const tableBody = [];
    
    for (let i = 0; i < children.length; i++) {
        const child = children[i];
        
        let mergedAssessment = {};
        if (child.id && child.id !== 'demo' && child.ownerUid) {
            try {
                const q = query(collection(db, `children/${child.id}/assessments`), orderBy('createdAt', 'desc'));
                const snapshot = await getDocs(q);
                snapshot.forEach(doc => {
                    const data = doc.data();
                    if (data.pertumbuhan && !mergedAssessment.pertumbuhan) mergedAssessment.pertumbuhan = data.pertumbuhan;
                    if (data.perkembangan && !mergedAssessment.perkembangan) mergedAssessment.perkembangan = data.perkembangan;
                    if (data.mental && !mergedAssessment.mental) mergedAssessment.mental = data.mental;
                    if (data.dayaDengar && !mergedAssessment.dayaDengar) mergedAssessment.dayaDengar = data.dayaDengar;
                    if (data.pemeriksaanMata && !mergedAssessment.pemeriksaanMata) mergedAssessment.pemeriksaanMata = data.pemeriksaanMata;
                    if (data.chat && !mergedAssessment.chat) mergedAssessment.chat = data.chat;
                    if (data.gpph && !mergedAssessment.gpph) mergedAssessment.gpph = data.gpph;
                });
            } catch (e) {
                console.error('Error fetching comprehensive data for child', child.name, e);
            }
        }
        
        if (Object.keys(mergedAssessment).length === 0 && child.lastAssessment) {
            mergedAssessment = child.lastAssessment;
        }

        const age = calculateAge(child.dob.toDate());
        const gender = child.gender === 'Laki-laki' ? 'L' : 'P';
        
        const fisik = mergedAssessment.pertumbuhan?.status || '-';
        const kpsp = mergedAssessment.perkembangan?.status || '-';
        const tdd = mergedAssessment.dayaDengar?.status || '-';
        const tdl = mergedAssessment.pemeriksaanMata?.dayaLihat?.status || '-';
        const kmme = mergedAssessment.mental?.status || '-';
        const chat = mergedAssessment.chat?.status || '-';
        const gpph = mergedAssessment.gpph?.status || '-';

        tableBody.push([
            i + 1,
            child.name,
            gender,
            age,
            fisik,
            kpsp,
            tdd,
            tdl,
            kmme,
            chat,
            gpph
        ]);
    }

    doc.autoTable({
        startY: 45,
        head: [['No', 'Nama Anak', 'L/P', 'Usia', 'Fisik', 'KPSP', 'TDD', 'TDL', 'KMME', 'CHAT', 'GPPH']],
        body: tableBody,
        theme: 'grid',
        headStyles: { fillColor: [79, 70, 229] }, // Indigo-600
        styles: { fontSize: 10, cellPadding: 3 },
        columnStyles: {
            0: { cellWidth: 10, halign: 'center' },
            2: { cellWidth: 10, halign: 'center' },
            3: { cellWidth: 20 },
            4: { halign: 'center' },
            5: { halign: 'center' },
            6: { halign: 'center' },
            7: { halign: 'center' },
            8: { halign: 'center' },
            9: { halign: 'center' },
            10: { halign: 'center' }
        }
    });

    // --- Footer ---
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(9);
        doc.setTextColor(150);
        doc.text(`Digenerate otomatis melalui SIKEMBANG | Halaman ${i} dari ${pageCount}`, 148, 200, { align: 'center' });
    }

    // --- Save the PDF ---
    downloadOrSharePDF(doc, `Laporan_Kelas_${className.replace(/\s/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);
};
